import React from 'react';
import './area info.css'
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon } from "mdbreact";
import "react-image-gallery/styles/css/image-gallery.css";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import allStrings from "../../assets/strings";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { BASE_END_POINT } from "../../urls";
import axios from "axios";
import { hasValue } from "../../validations/validations";
import { message } from "antd";
class AreaInfo extends React.Component {
  state = {
    actionType: this.props.location.state.actionType ? this.props.location.state.actionType === "EDIT" ? "EDIT" : "VIEW" : "VIEW",
    id: this.props.location.state.data.id,
    areaName_en: this.props.location.state.data.areaName_en,
    areaName_ar: this.props.location.state.data.areaName_ar,
    latitude: this.props.location.state.data.location.coordinates[1],
    longitude: this.props.location.state.data.location.coordinates[0],
  };

  constructor(props) {
    super(props)
    window.scrollTo(0, 0)
    if (this.props.isRTL) {
      allStrings.setLanguage('ar')
    } else {
      allStrings.setLanguage('en')
    }
  }

  updateArea = () => {
    const { areaName_en, areaName_ar, latitude, longitude } = this.state
    if (hasValue(areaName_en) && hasValue(areaName_ar)) {
      let l = message.loading('Wait..', 2.5)
      const data = {
        'areaName_en': areaName_en,
        'areaName_ar': areaName_ar,
        'location': [longitude, latitude]
      }

      axios.put(`${BASE_END_POINT}areas/${this.props.location.state.data.id}`, JSON.stringify(data), {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.props.currentUser.token}`,
          'Accept-Language': this.props.isRTL ? 'ar' : 'en'
        },
      })
        .then(response => {
          console.log("CITY UPDATED  ", response.data)
          l.then(() => message.success(allStrings.done, 2.5))
          this.props.history.goBack()
        })
        .catch(error => {
          console.log(error.response)
          l.then(() => message.error(allStrings.error, 2.5))
        })
    }
  }

  deleteArea = () => {
    let l = message.loading('Wait..', 2.5)
    axios.delete(`${BASE_END_POINT}areas/${this.props.location.state.data.id}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en'
      },
    })
      .then(response => {
        console.log("Area DELETED")
        l.then(() => message.success(allStrings.done, 2.5))
        this.props.history.goBack()
      })
      .catch(error => {
        console.log(error.response)
        l.then(() => message.error(allStrings.error, 2.5))
      })
  }

  submitHandler = event => {
    event.preventDefault();
    console.log(event.target.className)
    event.target.className += " was-validated";
    this.updateArea()
  };

  changeHandler = event => {
    this.setState({ [event.target.name]: event.target.value });
  };


  render() {
    if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('COUNTRIES')) return <Redirect to='/Home' />
    return (
      <div className="App">

        <MDBContainer>
          <MDBRow>

            <MDBCol md="12">
              <div className="infoCard">
                <Card className="editCard" style={{ overflow: 'visible', outline: 'none', marginBottom: '0px' }}>
                  <CardMedia
                    style={{ height: "0px" }}
                  />
                  <CardHeader></CardHeader>
                  <div style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row', display: 'flex' }}>
                    <div className="topIcon" style={{ background: 'linear-gradient(135deg, #1D9598, #127275)' }}>
                      <span className="material-icons" style={{ color: 'white', fontSize: 23 }}>'location_city'</span>
                    </div>
                    <div className="tableTitle" style={{
                      display: 'inline-block', marginTop: '-60px',
                      marginLeft: '0', marginRight: '0'
                    }}>
                      <p>{this.state.actionType === "VIEW" ? allStrings.areaInfo : allStrings.edit}</p>
                    </div>
                  </div>
                  <CardContent style={{ minHeight: "390px", outline: 'none' }}>
                    <MDBContainer>
                      <MDBRow>
                        <MDBCol md="12">
                          <form
                            className="needs-validation"
                            onSubmit={this.submitHandler}
                            noValidate
                          >

                            <div className="grey-text">
                              {this.state.actionType === "VIEW" &&
                                <MDBRow>
                                  <MDBCol md="12">
                                    <div className="md-form">
                                      <label htmlFor="form8" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>#</label>
                                      <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.id} type="text" id="form8" className="form-control" onChange={this.changeHandler} required validate />
                                      <div class="valid-feedback">{allStrings.correct}</div>
                                      <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                    </div>
                                  </MDBCol>

                                </MDBRow>
                              }
                              <MDBRow>
                                <MDBCol md="6">
                                  <div className="md-form">
                                    <label htmlFor="form65" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.englishName}</label>
                                    <input disabled={this.state.actionType === "VIEW" ? true : false} onInput={(e) => e.currentTarget.value = e.currentTarget.value.replace(/[^A-Za-z0-9-,.@%$؟'"?#*&()_^&!\\/\s-_]/g, '')} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.areaName_en} type="text" id="form645" name="areaName_en" className="form-control" onChange={this.changeHandler} required validate placeholder="أدخل اسم المنطقة بالانجليزية..." />
                                    <div class="valid-feedback">{allStrings.correct}</div>
                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                  </div>
                                </MDBCol>
                                <MDBCol md="6">
                                  <div className="md-form">
                                    <label htmlFor="form56" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.arabicName}</label>
                                    <input disabled={this.state.actionType === "VIEW" ? true : false} onInput={(e) => e.currentTarget.value = e.currentTarget.value.replace(/[^\u0600-\u06FF0-9\u0660-\u0669#.,@?؟%$_^*()/\\ _-]+/g, '')} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.areaName_ar} type="text" id="form56" name="areaName_ar" className="form-control" onChange={this.changeHandler} required validate placeholder="أدخل اسم المنطقة بالعربية..." />
                                    <div class="valid-feedback">{allStrings.correct}</div>
                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                  </div>
                                </MDBCol>
                              </MDBRow>
                              <MDBRow>
                                <MDBCol md="6">
                                  <div className="md-form">
                                    <label htmlFor="form65" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.latitude}</label>
                                    <input disabled={this.state.actionType === "VIEW" ? true : false} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} defaultValue={this.state.latitude} type="number" step="0.01" id="form65" name="latitude" className="form-control" onChange={this.changeHandler} required validate placeholder="خط العرض..." />
                                    <div class="valid-feedback">{allStrings.correct}</div>
                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                  </div>
                                </MDBCol>
                                <MDBCol md="6">
                                  <div className="md-form">
                                    <label htmlFor="form64" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.longitude}</label>
                                    <input disabled={this.state.actionType === "VIEW" ? true : false} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} defaultValue={this.state.longitude} type="number" step="0.01" id="form64" name="longitude" className="form-control" onChange={this.changeHandler} required validate placeholder="خط الطول..." />
                                    <div class="valid-feedback">{allStrings.correct}</div>
                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                  </div>
                                </MDBCol>
                              </MDBRow>
                            </div>
                            <br></br>
                            <br></br>
                            <div className="text-center">
                              {this.state.actionType === "EDIT" &&
                                <MDBBtn
                                  type="submit" style={{ background: 'linear-gradient(135deg, #1D9598, #127275)' }}
                                  rounded
                                  className="btn-block z-depth-1a"
                                >
                                  <MDBIcon icon="edit" className="mr-2" />
                                  {allStrings.updateArea}
                                </MDBBtn>
                              }{this.state.actionType === "VIEW" &&
                                <MDBBtn onClick={() => { this.deleteArea() }} rounded style={{ background: 'linear-gradient(135deg, #FF3547, #B71C1C)', color: '#fff' }} color="FF3547" className="btn-block z-depth-1a">
                                  <MDBIcon icon="trash-alt" className="mr-2" />
                                  {allStrings.remove}
                                </MDBBtn>
                              }

                            </div>
                          </form>
                        </MDBCol>
                      </MDBRow>
                    </MDBContainer>
                  </CardContent>
                </Card>
              </div>
            </MDBCol>
          </MDBRow>

        </MDBContainer>

      </div>
    )
  }
}


const mapToStateProps = (state) => ({
  isRTL: state.lang.isRTL,
  currentUser: state.auth.currentUser,
});

const mapDispatchToProps = {
};

export default withRouter(
  connect(mapToStateProps, mapDispatchToProps)(AreaInfo)
);
